import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { LicitacaoLstComponent } from './licitacao-lst/licitacao-lst.component';
import { LicitacaoShwComponent } from './licitacao-shw/licitacao-shw.component';

const routes: Routes = [
  {
    path: 'pesquisa/:pagina/:data1/:data2',
    component: LicitacaoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'pesquisa/:pagina/:data1/:data2/:filtro',
    component: LicitacaoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2',
    component: LicitacaoShwComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2/:filtro',
    component: LicitacaoShwComponent, canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicitacaoRoutingModule { }

